export default "__VITE_ASSET__CQ_Et3qS__"